import { ref } from "vue";

export interface ConfirmDialogOptions {
  title: string;
  message: string;
  html?: boolean;
  ok?: string | boolean;
  cancel?: string | boolean;
  /** Optional min-width for the dialog card (e.g. "700px"). Defaults to 350px. */
  width?: string;
}

// Reactive state for the dialog (module-level singleton)
const isVisible = ref(false);
const dialogOptions = ref<ConfirmDialogOptions>({
  title: "",
  message: "",
  html: false,
  ok: "OK",
  cancel: "Cancel"
});
let resolvePromise: ((value: boolean) => void) | null = null;

export function useConfirmDialog() {
  const show = (options: ConfirmDialogOptions): Promise<boolean> => {
    dialogOptions.value = {
      ...options,
      ok: options.ok === true ? "OK" : options.ok || "OK",
      cancel: options.cancel === true ? "Cancel" : options.cancel
    };
    isVisible.value = true;

    return new Promise((resolve) => {
      resolvePromise = resolve;
    });
  };

  const confirm = () => {
    isVisible.value = false;
    resolvePromise?.(true);
    resolvePromise = null;
  };

  const cancel = () => {
    isVisible.value = false;
    resolvePromise?.(false);
    resolvePromise = null;
  };

  return {
    isVisible,
    dialogOptions,
    show,
    confirm,
    cancel
  };
}

// Singleton instance for global access
export const confirmDialog = useConfirmDialog();
